export default __webpack_public_path__ + "static/media/new-gallery.2849d51a.svg";